import React, { useState } from "react";
import { Tooltip } from "reactstrap";

const CustomTooltip = ({
  // className = "",
  text = "",
  target = "",
  placement = "bottom",
  autohide = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!text || !target) {
    return <></>;
  }

  return (
    <Tooltip
      placement={placement}
      isOpen={isOpen}
      target={target}
      toggle={() => setIsOpen((prev) => !prev)}
      // className={className}
      autohide={autohide}
    >
      {text}
    </Tooltip>
  );
};

export default CustomTooltip;
